(function() {
  function initFooterAccordion() {
    // Handle mobile footer accordion
    const footerTitles = document.querySelectorAll('.footer-block__title');
    
    footerTitles.forEach(title => {
      // Skip if already initialized
      if (title.dataset.accordionInitialized === 'true') {
        return;
      }
      
      title.dataset.accordionInitialized = 'true';
      
      const handleClick = function(event) {
        // Check if we're on mobile (viewport width <= 768px)
        if (window.innerWidth <= 768) {
          // Don't prevent default if clicking on a link inside the title
          const clickedElement = event.target;
          if (clickedElement.tagName === 'A' || clickedElement.closest('a')) {
            return;
          }
          
          event.preventDefault();
          event.stopPropagation();
          
          // Toggle active class
          title.classList.toggle('active');
        }
      };
      
      title.addEventListener('click', handleClick);
      
      // Make title look clickable on mobile
      if (window.innerWidth <= 768) {
        title.style.cursor = 'pointer';
      }
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordion);
  } else {
    initFooterAccordion();
  }
  
  // Handle dynamic content loading (for Shopify theme editor)
  if (typeof window.Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', function(event) {
      // Small delay to ensure DOM is updated
      setTimeout(initFooterAccordion, 100);
    });
  }
  
  // Re-initialize on window resize to handle orientation changes
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      // Re-initialize to update cursor styles
      const footerTitles = document.querySelectorAll('.footer-block__title');
      footerTitles.forEach(title => {
        if (window.innerWidth <= 768) {
          title.style.cursor = 'pointer';
        } else {
          title.style.cursor = '';
        }
      });
    }, 250);
  });
})();
